module.exports = __webpack_public_path__ + "img/pay2.e82a9904.png";